import React from 'react';
import { Box, Layer, Heading, Text } from 'grommet';
import type { FromSampleClipModalProps } from './SignIn';

const FromSampleClipModal: React.FC<FromSampleClipModalProps> = ({
  onClose,
}) => {
  return (
    <Layer
      position={'center'}
      responsive={false}
      onClickOutside={onClose}
      background={'transparent'}
    >
      <Box
        background="#183710"
        pad="medium"
        gap="small"
        height={{ max: '624px' }}
        round={{ corner: 'top', size: '8px' }}
        width={{ max: '480px' }}
        alignSelf="center"
        flex
      >
        <Heading
          color="#ccff50"
          level={3}
          size="1.375rem"
          style={{ lineHeight: '1.272727' }}
          weight="bold"
        >
          Never miss a moment. Receive more than one clip per game.
        </Heading>
        <Box margin={{ bottom: 'xlarge' }}>
          <Text weight="bold">Sign in above to continue</Text>
        </Box>
      </Box>
    </Layer>
  );
};

export default FromSampleClipModal;
